import React from "react";

export default function useDoesUrlHaveData({
  url,
  retryDuration = 1000,
  retryLimit = 50,
}: {
  url: string;
  retryDuration?: number;
  retryLimit?: number;
}) {
  const [loading, setLoading] = React.useState<boolean>(true);
  const retryCount = React.useRef(0);

  React.useEffect(() => {
    let intervalTimer: NodeJS.Timeout | undefined;
    let isCancelled = false;

    retryCount.current = 0;

    const fetchRequest = async () => {
      if (isCancelled) return;

      try {
        let response = await fetch(url);

        if (isCancelled) return;

        if (response.status === 200) {
          setLoading(false);
          return;
        }

        intervalTimer = setInterval(async () => {
          if (isCancelled) {
            if (intervalTimer) clearInterval(intervalTimer);
            return;
          }

          if (retryCount.current >= retryLimit) {
            if (intervalTimer) clearInterval(intervalTimer);
            return;
          }

          retryCount.current++;

          try {
            let intResponse = await fetch(url);
            if (intResponse.status === 200) {
              setLoading(false);
              if (intervalTimer) clearInterval(intervalTimer);
            }
          } catch (error) {
            console.error("Fetch error:", error);
          }
        }, retryDuration);
      } catch (error) {
        console.error("Initial fetch error:", error);
      }
    };

    if (url) {
      setLoading(true);
      fetchRequest();
    }

    return () => {
      isCancelled = true;
      if (intervalTimer) {
        clearInterval(intervalTimer);
      }
    };
  }, [url, retryDuration, retryLimit]);

  return !loading;
}
